const SEPARADOR_FASE = " - ";
const NUMERO_PROCESSO_PATTERN = /([a-zA-Z\-\s]+ - )?\d{1,7}-\d{1,2}\.\d{4}\.\d\.\d{1,2}\.\d{1,4}/;

class NumeroProcesso {

    fase: string;
    numero: number;
    digito: number;
    ano: number;
    justica: number;
    tribunal: number;
    vara: number;

    constructor(fase?: string, numero?: number, digito?: number, ano?: number, justica?: number, tribunal?: number, vara?: number) {

        this.fase = fase;
        this.numero = numero;
        this.digito = digito;
        this.ano = ano;
        this.justica = justica;
        this.tribunal = tribunal;
        this.vara = vara;
    }

    static novo(): NumeroProcessoBuilder {
        return new NumeroProcessoBuilder();
    }

    static valueOf(numeroProcesso: string): NumeroProcesso {

        // numeroProcesso = numeroProcesso.replace(/\s/g, '');

        if (!this.isValido(numeroProcesso)) {
            throw new Error(numeroProcesso);
        }

        const split: string[] = numeroProcesso.split(SEPARADOR_FASE);
        let calda: string;
        let fase: string = "";
        if (split.length == 2) {
            fase = split[0];
            calda = split[1];
        } else {
            calda = split[0];
        }
        const parts: string[] = calda.split(/-|\./);
        const vara: number = parseInt(parts[parts.length - 1]);
        const tribunal: number = parseInt(parts[parts.length - 2]);
        const justica: number = parseInt(parts[parts.length - 3]);
        const ano: number = parseInt(parts[parts.length - 4]);
        const digito: number = parseInt(parts[parts.length - 5]);
        const numero: number = parseInt(parts[parts.length - 6]);

        return new NumeroProcesso(fase, numero, digito, ano, justica, tribunal, vara);
    }

    static isValido(numeroCompleto: string): boolean {
        return numeroCompleto && NUMERO_PROCESSO_PATTERN.exec(numeroCompleto) !== null;
    }

    public getNumero(): number {
        return this.numero;
    }

    public getAno(): number {
        return this.ano;
    }

    public getDigito(): number {
        return this.digito;
    }

    public getJustica(): number {
        return this.justica;
    }

    public getTribunal(): number {
        return this.tribunal;
    }

    public getVara(): number {
        return this.vara;
    }

    public getFase(): string {
        return this.fase || "";
    }

    public getFaseAtual(): string {// FIXME 
        const numeroProcesso = this.numeroProcessoFormatado();
        return numeroProcesso.substring(0, numeroProcesso.indexOf('-')).trim();
    }

    public numeroProcessoFormatado(): string {
        const fase: string = this.fase ? this.fase + SEPARADOR_FASE : "";
        const numero: string = this.numero.toString().padStart(7, '0');
        const digito: string = this.digito.toString().padStart(2, '0');
        const ano: string = this.ano.toString().padStart(4, '0');
        const tribunal: string = this.tribunal.toString().padStart(2, '0');
        const vara: string = this.vara.toString().padStart(4, '0');

        return `${fase}${numero}-${digito}.${ano}.${this.justica}.${tribunal}.${vara}`;
    }

    public semFase(): NumeroProcesso {
        const builder = new NumeroProcessoBuilder();
        return builder.comDigito(this.digito).comNumero(this.numero).daJustica(this.justica).daVara(this.vara).doAno(this.ano).doTribunal(this.tribunal).build();
    }

    public comFase(fase: string): NumeroProcesso {
        const numeroProcessoComNovaFase: string = fase + SEPARADOR_FASE + this.semFase().toString();
        return NumeroProcesso.valueOf(numeroProcessoComNovaFase);
    }
}


export default NumeroProcesso;

const NUMERO_JUSTICA_TRABALHO = 5;
export class NumeroProcessoBuilder {

    numeroProcesso: NumeroProcesso;

    constructor() {
        this.numeroProcesso = new NumeroProcesso();
    }
    public comNumero(numero: number): NumeroProcessoBuilder {
        this.numeroProcesso.numero = numero;
        return this;
    }

    public comDigito(digito: number): NumeroProcessoBuilder {
        this.numeroProcesso.digito = digito;
        return this;
    }

    public doAno(ano: number): NumeroProcessoBuilder {
        this.numeroProcesso.ano = ano;
        return this;
    }

    public daJustica(justica: number): NumeroProcessoBuilder {
        this.numeroProcesso.justica = justica;
        return this;
    }

    public daJusticaDoTrabalho(): NumeroProcessoBuilder {
        this.numeroProcesso.justica = NUMERO_JUSTICA_TRABALHO;
        return this;
    }

    public doTribunal(tribunal: number): NumeroProcessoBuilder {
        this.numeroProcesso.tribunal = tribunal;
        return this;
    }

    public daVara(vara: number): NumeroProcessoBuilder {
        this.numeroProcesso.vara = vara;
        return this;
    }

    public naFase(fase: string): NumeroProcessoBuilder {
        this.numeroProcesso.fase = fase;
        return this;
    }

    public build(): NumeroProcesso {
        return this.numeroProcesso;
    }
}